import { render, staticRenderFns } from "./UploadNewRole.vue?vue&type=template&id=03e204f7"
import script from "./UploadNewRole.vue?vue&type=script&lang=js"
export * from "./UploadNewRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports